
const open = window.XMLHttpRequest.prototype.open;
  function openReplacement() { // patch XMLHTTP requests
      this.addEventListener("load", async function () {
        //console.log('xml cart changed...outside...',this._url)
          if (this._url.includes('cart/change') || this._url.includes('cart/add') || this._url.includes('cart/update') || this._url.includes('cart/clear')) {
              console.log('xml cart changed...')
          }
      });
      return open.apply(this, arguments);
  }
  window.XMLHttpRequest.prototype.open = openReplacement;

  (function (ns, fetch) { // patch fetch requests
      if (typeof fetch !== 'function') {
          return;
      }
      ns.fetch = function () {
          const response = fetch.apply(this, arguments);
          response.then(async res => {
              if (res.url.includes('cart/change') || res.url.includes('cart/add') || res.url.includes('cart/update') || res.url.includes('cart/clear')) {
                  
              }
          });
          return response;
      }
  }(window, window.fetch))

document.querySelector(`.product-add-to-cart button`)?.addEventListener("click", function(e){
  setTimeout(async function (){
    var res = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
    })
    .then(response => {
      var res = response.json()
      return res;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    
    console.log('added...',res)
    var ln = res.items.length
    var counter = document.querySelector('.cart-count.badge')
    if(ln){
      counter.innerHTML = ln
      counter.style.display = 'inline-block'
    } else {
      counter.style.display = 'none'
    }
    
  }, 1500)
});


  